import { render, staticRenderFns } from "./AccommodationsList.vue?vue&type=template&id=97dd49dc&"
import script from "./AccommodationsList.vue?vue&type=script&lang=js&"
export * from "./AccommodationsList.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports